/**
* @description  在导航栏设置面包屑信息
* @param {Object} to {Object} from
* @returns String 面包屑信息
*/
export function setCrumbText(to,from){
  let crumbTextArr = []
  var meau = window.LS.get("SY") || '{}';
  if(meau!='{}'){
    let objArr = JSON.parse(meau).menu //获取菜单
    if(!objArr) return
    let arr = getMeau(objArr,to.path, to.meta.text)
    let arrFlag = getMeau1(objArr)
    let findArr = arrFlag.filter(q => q.url == to.path)
    if(findArr.length > 0){
      arr = arr[0].toString()
      crumbTextArr = arr.split('>') //先保存
    } else {
      // 不在菜单里面,子菜单之类
      let newArr =  getNavDetail(from.path) //获取上一个的
      // 当前的面包屑加一个
      // newArr.push(to.meta.text)
      crumbTextArr = newArr //先保存
    }
  }
  return crumbTextArr
}

// 查询指定url 返回resourcesName 数组
export  function getMeau(list, key, text, ico = '', site = '') {
    let currentArr = []
    list.map(item => {
        // 判断有没有子节点 NO
        if(item.children.length==0) {
        // && item.resourcesName==text
        //   这样会有点问题
            if(item.url==key){
                currentArr.push(site + ico + item.resourcesName)
            }
        }else {
        // 如果有 children 则进行递归
            let a =  getMeau(item.children, key, text, '>', site + ico + item.resourcesName )
            currentArr = currentArr.concat(a)
        }
    })
    return currentArr
};

//拍平
export  function getMeau1(list) {
    let currentArr = []
    list.map(item => {
        // 判断有没有子节点 NO
        if(item.children.length==0) {
            currentArr.push(item)
        }else {
        // 如果有 children 则进行递归
            let a =  getMeau1(item.children)
            item.children = []
            currentArr.push(item)
            currentArr = currentArr.concat(a)
        }
    })
    return currentArr
};

// 获取导航栏详情
export  function getNavDetail(url){
  // 先找 财税
  let localData = window.LS.get("taxList") || "[]";
  localData = JSON.parse(localData)
  let cur = localData.find(it=>{
    return it.path == url
  })
  if(!cur){// 后找 非财税
    let localData2 = window.LS.get("normalList") || "[]";
    localData2 = JSON.parse(localData2)
    cur = localData2.find(it=>{
      return it.path == url
    })
  }
  return cur?cur.crumb:[]
}

/**
 * 深度遍历对象属性，默认删除value为null、''、undefined的key
 * @param {Object} obj 过滤对象，必传
 * @param {Array} filterArray 自定义过滤的value值（ps:必须为数组），非必传，默认为['', null, undefined]
 * @return {Object}
 */
export function filterObjectEmpty(obj, filterArray = ['',null, undefined]) {
  function deep(obj) {
    for (const k in obj) {
      if (obj[k] instanceof Object) {
        deep(obj[k])
      } else if (filterArray.includes(obj[k])) {
        delete obj[k]
      }
    }
  }
  if (!(obj instanceof Object)) return obj
  const data = JSON.parse(JSON.stringify(obj))
  deep(data)
  return data
}
